import moment from "moment";
import { Icon, Tooltip, Tag } from "antd";
import React from "react";

const roundedFloat = (float) => {
  const decimalDigit = 4;
  const d = Math.pow(10, decimalDigit);
  return Math.round((float + Number.EPSILON) * d) / d;
};
export default (onClickDetail) => [
  {
    title: "วันที่",
    dataIndex: "created",
    render: (date) => {
      const datetime = new Date(date.Time);
      return moment(datetime).format("DD/MM/YYYY");
    },
  },
  {
    title: "ประเภท",
    render: (record) => {
      let label = "Balance";
      let colour = "purple";
      if (record["mcw_id"] > 1) {
        label = "Package";
        colour = "gold";
      }

      return <Tag color={colour}>{label}</Tag>;
    },
  },
  {
    title: "กระทำโดย",
    dataIndex: "admin_id",
    render: (text, record) => {
      if (text === 1) {
        return "Admin System";
      }

      if (text === 0) {
        return "ลูกค้า";
      }

      return record.admin_name || "-";
    },
  },
  {
    title: "จำนวนเงินก่อนหน้า",
    dataIndex: "balance_before",
    render: (amount,record) => {
      if (record["mcw_id"] > 1) {
        return "-";
      }

      const amountConverted = roundedFloat(amount).toFixed(4);
      if (amount > 0) {
        return <span style={{color: "green"}}>${amountConverted}</span>;
      }

      return <span style={{color: "red"}}>${amountConverted}</span>;
    },
  },
  {
    title: "จำนวนเงินที่เพิ่ม",
    dataIndex: "balance_added",
    render: (amount,record) => {
      if (record["mcw_id"] > 1) {
        return "-";
      }
      
      const amountConverted = roundedFloat(amount).toFixed(4);
      if (amount > 0) {
        return <span style={{color: "green"}}>${amountConverted}</span>;
      }

      return <span style={{color: "red"}}>${amountConverted}</span>;
    },
  },
  {
    title: "จำนวนหลังจากการเติมเงิน",
    dataIndex: "balance_after",
    render: (amount,record) => {
      if (record["mcw_id"] > 1) {
        return "-";
      }

      const amountConverted = roundedFloat(amount).toFixed(4);
      if (amount > 0) {
        return <span style={{color: "green"}}>${amountConverted}</span>;
      }

      return <span style={{color: "red"}}>${amountConverted}</span>;
    },
  },
  {
    title: "ดำเนินการ",
    dataIndex: "payment_id",
    render: (paymentId, record) => {
      let info = "ดูรายการ";
      let iconType = "database";
      if (paymentId === 0) {
        info = record.remark || "แอดมินเติมให้ลูกค้า";
        iconType = "info-circle";
      }

      if (record.admin_id > 0 && paymentId > 0) {
        info = `แอดมินอนุมัติรายการ`;
      }

      return (
        <Tooltip title={info}>
          <span
            style={{ cursor: "pointer", color: paymentId !== 0 && "#1890ff" }}
            onClick={() => {
              if (paymentId > 0) {
                return onClickDetail(paymentId, record);
              }
              return;
            }}
          >
            <Icon type={iconType} /> รายละเอียด
          </span>
        </Tooltip>
      );
    },
  },
];



// WEBPACK FOOTER //
// ./src/containers/PaymentLog/column.js